import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from './axiosBaseQuery'
import { baseUrl } from './axiosInstance'

const campaignApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl
  }),
  reducerPath: 'campaignApi',
  tagTypes: ['campaign', 'templates', 'audience'],
  endpoints: () => ({})
})

export default campaignApi
